import React from "react";
import localizationApi from "./Localizations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";
import {localesWithNoSocialLinks} from "./utils";

interface Props {
    locale: string;
    onLocaleChange: (locale: string) => void;
}

const FooterCompFh: React.FC<Props> = (props) => {
    const footerNcsaVariant = (locale: string) => {
        switch (locale) {
            case "pt-BR":
                return (<>
                    <div className="d-flex flex-wrap flex-row align-items-center justify-content-around">
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/ubisoft-white_emea_81038.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://club.ubisoft.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/uplay_83657.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://uplay.ubi.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/ubisoft-uplay-footer-logo-clear-h100_336425.png" alt="" />
                        </a>

                        <a target="_blank" rel="noopener noreferrer" href="http://www.playstation.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/ps4-logo.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.xbox.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/xbox-one-logo.png" alt="" />
                        </a>
                    </div>
                    <div className="d-flex flex-wrap flex-row align-items-center justify-content-center my-2">
                        <a target="_blank" rel="noopener noreferrer" href="http://www.geforce.com/" className="mx-4">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/nvidia-logo.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.pegi.info/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/vh-final_126698.png" alt="" />
                        </a>
                    </div>
                </>);
            default:
                return (<>
                    <div className="d-flex flex-wrap flex-row align-items-center justify-content-around">
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/ubisoft-white_emea_81038.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://club.ubisoft.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/uplay_83657.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://uplay.ubi.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/ubisoft-uplay-footer-logo-clear-h100_336425.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://blog.ubi.com">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/ubisoft-blog.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.playstation.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/ps4-logo.png" alt="" />
                        </a>
                    </div>
                    <div className="d-flex flex-wrap flex-row align-items-center justify-content-around">
                        <a target="_blank" rel="noopener noreferrer" href="http://www.xbox.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/xbox-one-logo.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://store.ubi.com/us/for-honor/575ffdd3a3be1633568b5024.html">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/pc-logo.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://store.ubiworkshop.com/?utm_source=Logo-Ubi-Websites&utm_medium=FH-Website&utm_term=Logo-Footer">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/Generic_UWS__Banner_100x230_213469.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.geforce.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/nvidia-logo.png" alt="" />
                        </a>
                    </div>
                    <div className="d-flex flex-wrap flex-row align-items-center justify-content-center my-2">
                        <a target="_blank" rel="noopener noreferrer" href="http://www.esrb.org/ratings/ratings_guide.jsp" className="mx-4">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/FH_ESRB-M-rating_277853.jpg" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.esrb.org/confirm/ubisoft-confirmation.jsp" className="mx-4">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/privacy-certified-globe-color-ubiosoft_110500.jpg" alt="" />
                        </a>
                    </div>
                </>);
        }
    };

    const footerNcsa = (
        <>
            {footerNcsaVariant(props.locale)}

            <div className="d-flex flex-column small pt-2">
                <p className="copy text-light text-center small">&copy; 2017 Ubisoft Entertainment. All Rights Reserved. For Honor, Uplay, the Uplay logo, Ubi.com, Ubisoft, and the Ubisoft logo are trademarks of Ubisoft Entertainment in the US and/or other countries. The "PS" Family logo is a registered trademark and "PS4" is a trademark of Sony Computer Entertainment Inc. Software platform logo (TM and ©) EMA 2006.</p>
                <div className="legal d-flex flex-row justify-content-center">
                    <a href="https://support.ubi.com" target="_blank" rel="noopener noreferrer" className="mx-2 text-light text-center small ">
                        CUSTOMER SUPPORT
                    </a>
                    <a href="https://club.ubisoft.com" target="_blank" rel="noopener noreferrer" className="mx-2 text-light text-center small ">
                        UBISOFT CLUB
                    </a>
                    <a href="https://legal.ubi.com/termsofuse" target="_blank" rel="noopener noreferrer" className="mx-2 text-light text-center small ">
                        UBISOFT TERMS OF USE
                    </a>
                    <a href="https://legal.ubi.com/privacypolicy" target="_blank" rel="noopener noreferrer" className="mx-2 text-light text-center small ">
                        UBISOFT PRIVACY POLICY
                    </a>
                </div>
            </div>
        </>
    );

    const footerEmeaVariant = (locale: string) => {
        switch (locale) {
            default:
                return (<>
                    <div className="d-flex flex-wrap flex-row align-items-center justify-content-around">
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/ubisoft-white_emea_81038.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://club.ubisoft.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/uplay_83657.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://uplay.ubi.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/ubisoft-uplay-footer-logo-clear-h100_336425.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.playstation.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/ps4-logo.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.xbox.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/xbox-one-logo.png" alt="" />
                        </a>
                    </div>
                    <div className="d-flex flex-wrap flex-row align-items-center justify-content-center my-2">
                        <a target="_blank" rel="noopener noreferrer" href="http://www.geforce.com/" className="mx-4">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/nvidia-logo.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.pegi.info/" className="mx-4">
                            <img src="https://ubistatic-a.akamaihd.net/0115/fh/images/PEGI_94869.png" alt="" />
                        </a>
                    </div>
                </>);
        }
    };
    const footerEmea = (
        <>
            {footerEmeaVariant(props.locale)}
            <div className="d-flex flex-column small">
                <p className="copy text-light text-center small">&copy; 2017 Ubisoft Entertainment. All Rights Reserved. For Honor, Uplay, the Uplay logo, Ubi.com, Ubisoft, and the Ubisoft logo are trademarks of Ubisoft Entertainment in the US and/or other countries. The "PS" Family logo is a registered trademark and "PS4" is a trademark of Sony Computer Entertainment Inc. Software platform logo (TM and ©) EMA 2006.</p>
                <div className="legal d-flex flex-row justify-content-center">
                    <a href="https://legal.ubi.com/LegalInfoUbisoftEMEA" target="_blank" rel="noopener noreferrer" className="mx-2 text-light text-center small ">
                        LEGAL INFORMATION
                    </a>
                    <a href="https://legal.ubi.com/termsofuse" target="_blank" rel="noopener noreferrer" className="mx-2 text-light text-center small ">
                        UBISOFT TERMS OF USE
                    </a>
                    <a href="https://legal.ubi.com/privacypolicy" target="_blank" rel="noopener noreferrer" className="mx-2 text-light text-center small ">
                        UBISOFT PRIVACY POLICY
                    </a>
                </div>
            </div>
        </>
    );

    const isNcsa = props.locale === "en-US" || props.locale === "fr-CA" || props.locale === "en-CA" || props.locale === "es-MX" || props.locale === "pt-BR";

    return (
        <footer className="bg-dark">
            <div className="container py-4">
                <div className="d-flex flex-row justify-content-between py-4">
                    <select className="p-2" onChange={(e) => props.onLocaleChange(e.target.value)} value={props.locale}>
                        {Object.keys(localizationApi.supportedLocales).map(k =>
                            <option key={k} value={k}>{localizationApi.supportedLocales[k]}</option>
                        )}
                    </select>
                    {!localesWithNoSocialLinks.includes(props.locale) &&
                        <ul className="nav">
                            <li className="nav-item"><a href="https://www.facebook.com/ForHonorGameUS" title="Facebook" className="nav-link"><FontAwesomeIcon icon={faFacebookF} color="#fff" /></a></li>
                            <li className="nav-item"><a href="https://twitter.com/forhonorgame?lang=fr" title="Twitter" className="nav-link"><FontAwesomeIcon icon={faTwitter} color="#fff" /></a></li>
                            <li className="nav-item"><a href="https://www.youtube.com/user/Ubisoft" title="YouTube" className="nav-link"><FontAwesomeIcon icon={faYoutube} color="#fff" /></a></li>
                            <li className="nav-item"><a href="http://forums-fr.ubi.com/forumdisplay.php/303-For-Honor?s=77b0fab4f454b5f36a473ee750980137" title="Forums" className="nav-link"><FontAwesomeIcon icon={["fas", "comments"]} color="#fff" /></a></li>
                        </ul>
                    }
                </div>
                {isNcsa ? footerNcsa : footerEmea}
            </div>
        </footer>
    );
};

export default FooterCompFh;
